<template>
    <div style="width:98%">
        <div class="title">Notification Settings</div>
        <div class="product">
            <el-row :gutter="24">
                <el-col :span="8"><div style="font-weight:bold">Products</div></el-col>
                <el-col :span="8"><div>&nbsp;</div></el-col>
                <el-col :span="8"><div style="font-weight:bold">Email</div></el-col>
            </el-row>
            <el-row :gutter="24">
                <el-col :span="8"><div>Out of stock alert</div></el-col>
                <el-col :span="8"><div>Wish List, Downloads or Listing</div></el-col>
                <el-col :span="8"><div><el-checkbox v-model="setting.product_inventory"></el-checkbox></div></el-col>
            </el-row>
        </div>
        <div ><el-button type="primary" @click="setNotice()">Save</el-button></div>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";

export default {
    data() {
        return {
          setting:{
              product_inventory: false
          }
        }
      },
    methods: {
        setNotice(){
            this.loading = true;
            cmofferApi
                .setNotice(
                    {notification:this.setting},
                    "post"
                )
                .then((res) => {
                    this.loading = false;
                    this.$message.success(
                        this.$i18n.locale == "zh" ? "成功" : "Success"
                    );
                    this.closeDialog();
                });
        },
        //获取通知设置
        getNotice() {
            this.loading = true;
            cmofferApi
                .getNotice(
                    {},
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.setting = res.data;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        
    },
    activated() {
        this.getNotice();
    },
    components: {
    },
    computed: {
    },
    watch: {

    },
};
</script>
<style scoped>
    .title{
        text-align:left;
        padding:20px 0 20px 20px;
        font-size:24px;
        height:30px;
        font-weight:bold
    }
    .el-row {
        border:none;
        border-bottom: 1px solid #ccc;
        padding:20px;
    }
    .el-col {
        border-radius: 4px;
    }
    .product{
        padding:20px 0 20px 20px;
        font-size: 14px;
    }
    .product div{
        text-align: left;
    }
</style>
